import { useState } from 'react';
import { useGetList, useGetIdentity } from 'react-admin';
import moment from 'moment';

const useQuests = () => {
    const [now] = useState(moment());
    const { data: account } = useGetIdentity();
    const { data: lastTimeEntries } = useGetList(
        'time_entries',
        {
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'date', order: 'DESC' },
            filter: { user_id: account?.id }
        }
    );
    const { data: lastWeeklies } = useGetList(
        'weeklies',
        {
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'date', order: 'DESC' },
            filter: { user_id: account?.id }
        }
    );
    const { total: suggestionCount } = useGetList(
        'suggestions',
        {
            pagination: { page: 1, perPage: 1 },
            sort: { field: 'id', order: 'DESC' },
            filter: { status: 'new', unvoted_by: account?.id }
        }
    );

    let warningTimesheet = false;
    if (lastTimeEntries?.length > 0) {
        const lastEntryDate = lastTimeEntries[0].date;
        warningTimesheet = now.diff(moment(lastEntryDate), 'days') >= 7;
    }
    let warningWeekly = false;
    if (lastWeeklies?.length > 0) {
        const lastWeeklyDate = lastWeeklies[0].date;
        warningWeekly = now.diff(moment(lastWeeklyDate), 'days') >= 7;
    }
    let warningLeaves = false;
    let currentDay = now.date();
    if (currentDay >= 23 && currentDay <= 26) {
        warningLeaves = true;
    }
    let warningSuggestions = suggestionCount > 0;

    const unfinishedQuestCount = [warningTimesheet, warningWeekly, warningLeaves, warningSuggestions].filter(Boolean).length;

    return {
        warningTimesheet,
        warningWeekly,
        warningLeaves,
        warningSuggestions,
        suggestionCount,
        lastTimeEntries,
        lastWeeklies,
        unfinishedQuestCount
    };
}

export default useQuests;